import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';

function AddFeedback() {
  const navigate = useNavigate();
  const location = useLocation();
  const [heading, setHeading] = useState('Add');
  const { register, handleSubmit, formState: { errors, }, reset, setValue } = useForm({
    defaultValues: {
      id: null,
      username: "",
      comments: "",
    },
  });

  const handleBack = (e) => {
    e.preventDefault();
    navigate('/feedback');
  }

  useEffect(() => {
    let feedbackId = location.pathname.split('/')[2];
    if (feedbackId == null) {
      setHeading('Add');
    }
    else {
      setHeading('View');
      setValue('id', feedbackId);
    }
  }, [location]);

  const onSubmit = (data) => {
    alert('Add submit logic');
    console.log(data);
    //Logic to save data
    handleCancel();
  }

  const handleCancel = (e) => {
    console.log('cancel clicked');
    reset({ username: '', comments: '' });
  }

  return (
    <Row>
      <Col md={12}>
        <Card className='mb-4'>
          <CardHeader className='pb-0'>
            <Row>
              <Col md={9}>
                <h4>{heading} Feedback Details</h4>
              </Col>
              <Col md={3} className='d-grid d-md-flex justify-content-md-end d-sm-block'>
                <Button variant='outline-primary' className='btn-sm' onClick={handleBack}>Back</Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className='px-0 pt-0 pb-2'>
            <Form onSubmit={handleSubmit(onSubmit)} className='p-3'>
              <Row className="mb-3">
                <input type='hidden' {...register('id')}></input>
                <Form.Group controlId="name" className="col-md-6 col-sm-12">
                  <Form.Label>User Name <span className='text-danger'>*</span></Form.Label>
                  <Form.Control type="text" placeholder="User Name" {...register("username", { required: "User name is required." })} />
                  <span className='text-xs text-danger'>{errors.username?.message}</span>
                </Form.Group>
                {/* <Form.Group controlId="parentCategory" className="col-md-6 col-sm-12">
                  <Form.Label>Discount <span className='text-danger'>*</span></Form.Label>
                  <Form.Control type="text" placeholder="Discount" {...register("discount", { required: "Discount is required." })} />
                  <span className='text-sm text-danger'>{errors.discount?.message}</span>
                </Form.Group> */}
              </Row>
              <Row className="mb-3">
                <Form.Group controlId="comments" className="col-md-6 col-sm-12">
                  <Form.Label>Comments <span className='text-danger'>*</span></Form.Label>
                  <Form.Control as="textarea" rows={3} placeholder="Comments" {...register("comments", {required:"Comments is required.", maxLength: { value: 500, message: "Maximum 500 characters allowed." } })} />
                  <span className='text-xs text-danger'>{errors.comments?.message}</span>
                </Form.Group>
              </Row>

              <Row >
                <Col md={12} className='d-grid gap-2 d-md-flex flex-md-row-reverse'>
                  <Button variant="primary" className='me-md-2' type="submit">Submit</Button>
                  <Button variant="dark" type="button" onClick={handleCancel}>Cancel</Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default AddFeedback